import { useEffect, useRef, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import { FaCode, FaExternalLinkAlt, FaLink, FaPlus, FaTrash, FaEdit, FaLaptopCode, FaUser, FaKey } from "react-icons/fa"
import { Button } from "@mui/material"
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useSelector } from "react-redux";
import PaginationItem from "../components/ui/components/Pagination";
import SoftwareBoxItemContainer from "../components/proyectos/SoftwareBoxItemContainer";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import Modal from "../components/ui/Modal";
import CheckBox from "../components/ui/components/CheckBox";
import MainSaveButton from "../components/ui/components/MainSaveButton";
import DescriptionModal from "../components/proyectos/DescriptionModal";
import SoftwareRowItemContainer from "../components/proyectos/SoftwareRowItemContainer";
import ChipInfo from "../components/proyectos/ChipInfo";
import TooltipInfoQuestion from "../components/ui/components/TooltipInfoQuestion";
import { toast } from "react-toastify";
import Selector from "../components/ui/components/Selector";
import { Limits10_50 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";
import DateInput from "../components/ui/components/DateInput";
import { serviceStatus } from "../utils/rawData/serviceStatus";
import FilterButton from "../components/ui/components/FilterButton";


const ProyectosSoftware = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const isOperative = user.area.toUpperCase() !== "COMERCIAL" && user.area.toUpperCase() !== "ADMINISTRACION"
  const isCommercial = user.area.toUpperCase() === "COMERCIAL"

  const [clients, setClients] = useState([])
  const [workers, setWorkers] = useState([])
  const [areaWorkers, setAreaWorkers] = useState([])

  const [softwareServices, setWebServices] = useState([])
  const [loadingStatus, setLoadingStatus] = useState(false)

  // Por defecto aparecen los servicios mas contratados de la agencia seleccionados
  // Aula virtual, Super Tiendas Virtuales, Landing Page ADS y Software de informativas
  const [serviceFilters, setServiceFilters] = useState(["66cfd3fc5a0dab807ba0c2af"])

  // Por defecto aparecen los proyectos que nos interesan
  const [statusFilters, setStatusFilters] = useState(["Por comenzar", "En proceso", "Terminado con exito"])

  const [view, setView] = useState("Horizontal")

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)

  const [totalDocs, setTotalDocs] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [agencyWeb, setAgencyWeb] = useState(false)

  const [brandName, setBrandName] = useState("") // Búsqueda de texto de la marca

  const [responsible, setResponsible] = useState("")

  // Modal de demo - Gestiona los items del registro padre 67ba060a7510267b9cef8ced
  const DEMO_PARENT_ID = "67ba060a7510267b9cef8ced"
  const [openModalDemo, setOpenModalDemo] = useState(false)
  const [demos, setDemos] = useState([]) // items del registro padre
  const [demoTab, setDemoTab] = useState("list") // "list" | "create"
  const [demoForm, setDemoForm] = useState({
    itemName: "",
    itemLink: "",
    subCategoryLinks: [],
  })
  const [editingDemoIndex, setEditingDemoIndex] = useState(null) // índice del item que se está editando
  const [copiedKey, setCopiedKey] = useState(null)

  const getDemos = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/accesosAreaComercial/${DEMO_PARENT_ID}`)
      setDemos(response.data.items || [])
    } catch (e) {
      toast.error("Error al obtener los demos")
    }
  }

  const saveDemosItems = async (updatedItems) => {
    try {
      await axios.put(`${BACKEND}/api/accesosAreaComercial/${DEMO_PARENT_ID}`, {
        items: updatedItems,
      })
      setDemos(updatedItems)
    } catch (e) {
      toast.error("Error al guardar los demos")
      throw e
    }
  }

  const createDemo = async () => {
    try {
      const newItem = { ...demoForm }
      const updatedItems = [...demos, newItem]
      await saveDemosItems(updatedItems)
      toast.success("Demo creado con éxito")
      resetDemoForm()
      setDemoTab("list")
    } catch (e) {
      // error ya manejado en saveDemosItems
    }
  }

  const updateDemo = async () => {
    try {
      const updatedItems = demos.map((item, i) =>
        i === editingDemoIndex ? { ...demoForm } : item
      )
      await saveDemosItems(updatedItems)
      toast.success("Demo actualizado con éxito")
      resetDemoForm()
      setDemoTab("list")
    } catch (e) {
      // error ya manejado en saveDemosItems
    }
  }

  const resetDemoForm = () => {
    setDemoForm({ itemName: "", itemLink: "", subCategoryLinks: [] })
    setEditingDemoIndex(null)
  }

  const startEditDemo = (demo, index) => {
    setEditingDemoIndex(index)
    setDemoForm({
      itemName: demo.itemName || "",
      itemLink: demo.itemLink || "",
      subCategoryLinks: demo.subCategoryLinks || [],
    })
    setDemoTab("create")
  }

  const addSubCategoryLink = () => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: [...prev.subCategoryLinks, { itemName: "", itemLink: "", user: "", password: "" }]
    }))
  }

  const handleCopyToClipboard = (text, key) => {
    navigator.clipboard.writeText(text)
    setCopiedKey(key)
    setTimeout(() => setCopiedKey(null), 1500)
  }

  const removeSubCategoryLink = (index) => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: prev.subCategoryLinks.filter((_, i) => i !== index)
    }))
  }

  const updateSubCategoryLink = (index, field, value) => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: prev.subCategoryLinks.map((link, i) =>
        i === index ? { ...link, [field]: value } : link
      )
    }))
  }

  // Modal de comentarios
  const [openModalComments, setOpenModalComments] = useState(false) // Modal comentarios
  const [openModalDescription, setOpenModalDescription] = useState(false) // Modal descripción
  const [selectedService, setSelectedService] = useState({}) // Info servicio seleccionado
  
  const getClients = async () => { // Obtener los clientes
    try {
      setLoadingStatus(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getClientsByServiceCategory?category=Software&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (statusFilters) {
        body.statusFilters = statusFilters
      }

      if (serviceFilters) {
        body.serviceFilters = serviceFilters
      }

      if (agencyWeb) {
        url += `&activoAgencia=${agencyWeb}`
      }

      if (startDate) {
        url += `&startDate=${new Date(startDate).toISOString()}`
      }

      if (endDate) {
        url += `&endDate=${new Date(endDate).toISOString()}`
      }

      if (responsible) {
        url += `&responsible=${responsible}`
      }

      const response = await axios.post(url, body)

      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

      setLoadingStatus(false)

    } catch (error) {
      toast.error("Error al obtener los servicios")
      return null
    }
  }

  const getWorkers = async () => { // Obtener los trabajadores
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`)
      const filteredWorkers = response.data.docs.filter(worker => worker.area.toUpperCase() === "COMERCIAL" || worker.area.toUpperCase() === "ADMINISTRACION")
      const filteredAreaWorkers = response.data.docs.filter(worker => worker.puesto.toUpperCase() === "DESARROLLADOR FULL STACK")
      setWorkers(filteredWorkers)
      setAreaWorkers(filteredAreaWorkers)
    } catch (error) {
      return false
    }
  }

  const getWebServices = async () => { // Obtener los servicios de webs
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=Software&limit=0`)
      setWebServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => { // Obtenemos los clientes
    getWebServices()
    getClients()
    getWorkers()
    getDemos()
  }, [])

  useEffect(() => { // Obtenemos los clientes cada que cambia la página y el límite
    getClients()
  }, [page, limit])

  const handlerChangeServiceFilter = (service, checked) => { // Manejador para el selector de servicios
    if (checked) {
      setServiceFilters((prev) => [...prev, service.id])
    } else {
      setServiceFilters((prev) => 
      prev.filter((serviceId) => serviceId !== service.id))
    }
  }

  const handlerChangeStatusFilter = (newStatus, checked) => { // Manejador para el selector de estados
    if (checked) {
      setStatusFilters((prev) => [...prev, newStatus])
    } else {
      setStatusFilters((prev) =>
      prev.filter((status) => status !== newStatus))
    }
  }

  useEffect(() => {
    getClients()
  }, [agencyWeb, startDate, endDate, responsible])

  const didMountFiltersRef = useRef(false)
    useEffect(() => {
      if (!didMountFiltersRef.current) {
        didMountFiltersRef.current = true
        return
      }
      const timeout = setTimeout(() => {
        getClients();
      }, 3000);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, statusFilters]);

  const [dates, setDates] = useState([]);

  useEffect(() => {
    generateCalendar();
  }, [clients]);

  const generateCalendar = () => { // Genera el calendario en la parte superior con los días y los eventos
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 4); // días atrás
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 5); // días adelante

    let currentDate = new Date(startDate);
    const newDates = [];

    // Crear las fechas para el calendario (7 días atrás y 8 días adelante)
    while (currentDate <= endDate) {
      newDates.push({ date: new Date(currentDate), events: [] }); // Inicializamos las fechas sin eventos
      currentDate.setDate(currentDate.getDate() + 1); // Avanzamos un día
    }

    // Extraer y ordenar los servicios de los clientes por su fecha de finalización (endDate)
    const servicesWithDates = clients
      .flatMap(client => {
        // Obtenemos todos los servicios del cliente
        return client.services || [];
      })
      .filter(service => service !== null && service !== undefined) // Filtramos los servicios nulos
      .sort((a, b) => a.eventDate - b.eventDate); // Ordenamos los servicios por fecha de finalización (endDate)

    // Asignamos los eventos a las fechas correspondientes
    servicesWithDates.forEach(service => {
      // Comparamos las fechas ignorando la parte de la hora
      const eventIndex = newDates.findIndex(dateObj => {
        return dateObj.date.toISOString().split('T')[0] === service.fechaFin.split('T')[0]; // Compara solo la fecha (YYYY-MM-DD)
      });
    
      if (eventIndex !== -1) {
        newDates[eventIndex].events.push(service); // Añadimos el evento a la fecha correspondiente
      }
    });

    // Ordenamos las fechas por su valor (aunque ya deberían estar ordenadas)
    newDates.sort((a, b) => a.date - b.date);
    // Actualizamos el estado con las fechas y eventos asignados
    setDates(newDates);
  };

  const [highlightedRow, setHighlightedRow] = useState(null); // Estado para manejar la fila resaltada
  const serviceRefs = useRef([]); // Usamos un array para almacenar las referencias a las filas de los servicios

  // Permisos
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    isAssistant: false,
    isBossArea: false,
  });

  const definePermissions = (user) => {
    const updatedPermissions = {
      isAdmin: user.area.toUpperCase() === "ADMINISTRACION",
      isAssistant: user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() === "ASISTENTE",
      isBossArea: user.area.toUpperCase() === "SOFTWARE" && user.puesto.toUpperCase() === "DESARROLLADOR FULL STACK",
      isUserArea: user.area.toUpperCase() === "SOFTWARE",
    };
    setPermissions(updatedPermissions);
  };
  
  useEffect(() => {
    if (user) definePermissions(user);
  }, [user]);

  //Descripcion
  const parseDescription = (description) => { // Parsear la info
    if (!description || typeof description !== "string") {
      return [];
    }
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = selectedService?.customDescriptionActive
  ? selectedService?.customDescriptionText
  : selectedService?.servicio?.preciosUnitarios.find(
      (precioUnit) => precioUnit?.plan.id === selectedService?.planServicio?.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText)

  // Gestión de columnas activas y permisos

  const conditions = {
    isAdmin: isAdmin,
    isOperative: isOperative, 
    isCommercial: isCommercial
  }

  // Estado para controlar la visibilida ddel modal
  const [showColFiltersModal, setShowColFiltersModal] = useState(false);

  // Definir combos para el rapido seleciconado de opciones
  const combos = [
    // { id: 1, name: "Administratico", cols: [1, 2, 4, 5, 6, 7, 8, 13, 15, 16, 17, 19, 20, 21, 24, 25, 26, 27, 28, 29, 30, 31] },
    // { id: 2, name: "Proyecto", cols: [1, 2, 4, 5, 6, 7, 8, 13, 17, 18, 21, 25, 33, 34, 36, 37, 38] },
    // { id: 3, name: "Horizontal", cols: [1, 2, 4, 5, 6, 7, 8, 13, 14, 21, 22, 23, 24, 32] },
    // { id: 5, name: "Todas", cols: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38] }
  ];

  //Columnas activas, con restricciones por áreas
  const cols = [
    { first: true, sticky: true, name: "Coti", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { second: true, name: "Porcentaje proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { third: true, name: "Cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Ir al proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link Drive", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Recompra potencial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Moroso", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "ID Cotización", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Servicio", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Estado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente" },
    { name: "Formulario", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Descripción servicio", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios operativa", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Plan", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Nro encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Tipo cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { name: "Responsable", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema" },
    { name: "CheckList", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", },
    { name: "Fecha venta o ingreso", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true}, chipContent: "Sistema", description: "Fecha cuando el cliente hace el primer pago" },
    { name: "Fecha inicio proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", description: "Fecha en cuando el especialista tiene la primera reunion en el sistema según la primera reunión, sin embargo es modificable por el especialista" },
    { name: "Información enviada", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { name: "Fecha envío info al 100%", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, description: "Esta en la fecha cuando realmente se envio la informacion segun el especialista o operativa" },
    { name: "Vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Fecha entrega", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Admin", description: "Fecha cuando el cliente paga el servicio al 100% y se entregan credenciales, accesos, migracion, capacitación" },
    { name: "Duración del proyecto establecido", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, descripcion: "Tiempo en dias respecto a la duracion total del proyecto establecida por administración" },
    { name: "Duración (hasta la fecha de hoy si esta en proceso)", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, description: "Tiempo en dias que lleva el proyecto desde la fecha de la primera reunion hasta la fecha de hoy" },
    { name: "Duración real del proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, description: "Tiempo en dias del proyecto desde que se vendio o se hizo el primer pago hasta que se entrego el proyecto al 100%" },
    { name: "Precio venta", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { name: "Link desarrollo", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link oficial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Copia seguridad referencia", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Capacitación hecha", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Control de calidad", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente" },
    { name: "Link Github", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link flujo", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link roadmap", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link esquema", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link manual de uso", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link capacitación", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }));

  // Función helper para evaluar si una columna debe mostrarse
  const shouldShowColumn = (col) => {
    // Check if column is enabled in colFilters
    if (!colFilters[col.id]) return false;
    // Check conditions
    if (!col.conditions) return true;
    return Object.keys(col.conditions).some(role => conditions[role] && col.conditions[role]);
  };

  const userHasAccess = (col) => {
    if (isAdmin && col.conditions.isAdmin) return true;
    if (isOperative && col.conditions.isOperative) return true;
    if (isCommercial && col.conditions.isCommercial) return true;
    return false;
  };

  const [colFilters, setColFilters] = useState(() => {
    const initialFilters = {};
    colsWithIds.forEach(col => {
      initialFilters[col.id] = col.show;
    });
    return initialFilters;
  });

  // Calcular offsets dinámicos para columnas sticky según cuáles son visibles
  const stickyOffsets = (() => {
    const defs = [
      { key: 'first', width: 3.5 },
      { key: 'second', width: 6.2 },
      { key: 'third', width: 15 },
    ];
    const offsets = {};
    let cumulative = 0;
    for (const def of defs) {
      offsets[def.key] = `${cumulative}rem`;
      const stickyCol = colsWithIds.find(c => c[def.key]);
      if (stickyCol && shouldShowColumn(stickyCol)) {
        cumulative += def.width;
      }
    }
    return offsets;
  })();

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal de comentarios del proyecto
        activeModal={openModalComments}
        onClose={() => {setOpenModalComments(false); setSelectedService({})}}
        title="Comentarios proyecto"
        className="max-w-6xl"
        centered
      >
        <div className="flex flex-col gap-2">

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Cliente: </span>
            <span className="font-light">{selectedService?.cotizacion?.cliente?.nombreComercial}</span>
          </div>

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Servicio: </span>
            <span className="font-light">{selectedService?.servicio?.name}</span>
          </div>

          <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
          {/* Sección de comentarios */}
          <div className="max-h-[600px] overflow-y-auto">
            {selectedService?.comentariosOperativa?.map((comment, index) => (
              <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

                <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                  <div className="flex flex-row gap-2 items-center justify-center">
                    <img
                      src={comment?.usuario?.foto?.url || user?.foto?.url}
                      alt={comment?.usuario?.nombre || user?.nombre}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name} - <span className="text-xs font-light text-gray-600 lowercase">{comment?.usuario.puesto || user.puesto}</span></span>
                  </div>
                  <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
                </div>

                <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
              </div>
            ))}
          </div>

          {/* Sección para agregar un nuevo comentario */}
          {/* <div className="mt-3">
            <h3 className="text-xs font-bold text-gray-700">Añadir comentario:</h3>
            <textarea
              className="w-full p-3 mt-2 border text-xs border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="2"
              placeholder="Escribe tu comentario aquí..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <button
              onClick={handleAddComment}
              className="mt-3 px-4 py-2 bg-blue-600 text-xs text-white rounded-md hover:bg-blue-700 focus:outline-none"
            >
              Agregar Comentario
            </button>
          </div> */}
        </div>
      </Modal>

      <Modal // Modal de filtros de columnas
        activeModal={showColFiltersModal}
        onClose={() => {setShowColFiltersModal(false)}}
        title="Filtros de columnas"
        className="max-w-6xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-row gap-2 items-center justify-start">
            {combos.map((combo) => (
              <button 
                key={combo.id} 
                className="flex flex-row items-center justify-start gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors duration-200"
                onClick={() => {
                  // Create new filters object with all columns initially false
                  const newColFilters = {};
                  
                  // Set all columns to false first
                  colsWithIds.forEach(col => {
                    newColFilters[col.id] = false;
                  });
                  
                  // Then set only the combo columns to true
                  combo.cols.forEach(colId => {
                    newColFilters[colId] = true;
                  });
                  
                  setColFilters(newColFilters);
                }}
              >
                <span className="text-xs font-semibold text-gray-700">{combo.name}</span>
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2 items-center justify-between">
            {colsWithIds
              .filter(col => userHasAccess(col))
              .map((col) => (
                <div key={col.id} className="flex flex-row items-center justify-start gap-2">
                  <CheckBox
                    checked={colFilters[col.id] || false}
                    onChange={(e) => {
                      setColFilters((prev) => ({
                        ...prev,
                        [col.id]: e.target.checked
                      }));
                    }}
                  />
                  <span className="text-xs font-semibold text-gray-700">{col.name}</span>
                </div>
              ))
            }
          </div>
        </div>

      </Modal>

      <DescriptionModal
        openModalDescription = {openModalDescription}
        brandName = {selectedService?.cotizacion?.cliente?.nombreComercial}
        serviceName = {selectedService?.servicio?.name}
        parsedDescription = {parsedDescription}
        setOpenModalDescription = {setOpenModalDescription}
        setSelectedService = {setSelectedService}
      />

      <Modal // Modal de demos de software
        activeModal={openModalDemo}
        onClose={() => {
          setOpenModalDemo(false)
          resetDemoForm()
          setDemoTab("list")
        }}
        title="Demos Software"
        className="max-w-5xl"
        centered
      >
        <div className="flex flex-col gap-4">
          {/* Tabs */}
          <div className="flex flex-row gap-2 border-b border-gray-200 pb-2">
            <button
              className={`px-4 py-2 text-xs font-bold rounded-t-md transition-all duration-200 ${demoTab === "list" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
              onClick={() => { setDemoTab("list"); resetDemoForm() }}
            >
              Demos existentes ({demos.length})
            </button>
            <button
              className={`px-4 py-2 text-xs font-bold rounded-t-md transition-all duration-200 ${demoTab === "create" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
              onClick={() => { setDemoTab("create"); resetDemoForm() }}
            >
              <FaPlus className="inline mr-1" />
              {editingDemoIndex !== null ? "Editar demo" : "Nuevo demo"}
            </button>
          </div>

          {/* Aclaración general */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-xs text-blue-800">
            <p className="font-semibold mb-1">¿Cómo funciona?</p>
            <ul className="list-disc ml-4 flex flex-col gap-1">
              <li><span className="font-semibold">Sin sub-enlaces:</span> el botón redirigirá directamente al link del demo.</li>
              <li><span className="font-semibold">Con sub-enlaces:</span> el botón desplegará las opciones para elegir a cuál acceder.</li>
            </ul>
          </div>

          {/* Lista de demos existentes */}
          {demoTab === "list" && (
            <div className="flex flex-col gap-2 max-h-[500px] overflow-y-auto">
              {demos.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-8">No hay demos registrados aún.</p>
              ) : (
                demos.map((demo, index) => (
                  <div key={demo.id || index} className="flex flex-col border border-gray-200 rounded-lg px-4 py-3 bg-white hover:shadow-sm transition-all duration-200">
                    <div className="flex flex-row items-center justify-between">
                      <div className="flex flex-row items-center gap-3">
                        <FaLaptopCode className="text-blue-500" />
                        <span className="text-sm font-bold text-gray-800">{demo.itemName}</span>
                        {demo.subCategoryLinks && demo.subCategoryLinks.length > 0 ? (
                          <span className="text-[10px] bg-purple-100 text-purple-700 font-semibold px-2 py-0.5 rounded-full">Desplegable · {demo.subCategoryLinks.length} sub-enlaces</span>
                        ) : (
                          demo.itemLink ? (
                            <a href={demo.itemLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline text-xs flex items-center gap-1">
                              <FaExternalLinkAlt className="text-[10px]" /> Link directo
                            </a>
                          ) : (
                            <span className="text-[10px] bg-yellow-100 text-yellow-700 font-semibold px-2 py-0.5 rounded-full">Sin link</span>
                          )
                        )}
                      </div>
                      <div className="flex flex-row gap-2">
                        <button onClick={() => startEditDemo(demo, index)} className="p-2 hover:bg-gray-100 rounded-md transition-all">
                          <FaEdit className="text-green-600 text-sm" />
                        </button>
                      </div>
                    </div>
                    {/* Sub-links */}
                    {demo.subCategoryLinks && demo.subCategoryLinks.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2 ml-8">
                        {demo.subCategoryLinks.map((sub, subIdx) => (
                          <div key={sub.id || subIdx} className="flex items-center gap-1">
                            <a
                              href={sub.itemLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-xs bg-gray-100 text-blue-600 hover:bg-gray-200 px-3 py-1 rounded-full flex items-center gap-1 transition-all duration-200"
                            >
                              <FaExternalLinkAlt className="text-[8px]" />
                              {sub.itemName}
                            </a>
                            {sub.user && (
                              <button
                                onClick={() => handleCopyToClipboard(sub.user, `demo-${index}-user-${subIdx}`)}
                                className={`p-1.5 rounded-full transition-all duration-150 ${
                                  copiedKey === `demo-${index}-user-${subIdx}`
                                    ? 'text-green-600 bg-green-50'
                                    : 'text-gray-400 hover:text-blue-600 hover:bg-blue-50'
                                }`}
                                title={copiedKey === `demo-${index}-user-${subIdx}` ? "¡Copiado!" : "Copiar usuario"}
                              >
                                <FaUser className="text-[9px]" />
                              </button>
                            )}
                            {sub.password && (
                              <button
                                onClick={() => handleCopyToClipboard(sub.password, `demo-${index}-pass-${subIdx}`)}
                                className={`p-1.5 rounded-full transition-all duration-150 ${
                                  copiedKey === `demo-${index}-pass-${subIdx}`
                                    ? 'text-green-600 bg-green-50'
                                    : 'text-gray-400 hover:text-amber-600 hover:bg-amber-50'
                                }`}
                                title={copiedKey === `demo-${index}-pass-${subIdx}` ? "¡Copiado!" : "Copiar contraseña"}
                              >
                                <FaKey className="text-[9px]" />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}

          {/* Formulario para crear/editar demo */}
          {demoTab === "create" && (
            <form
              className="flex flex-col gap-4 max-h-[500px] overflow-y-auto pr-1"
              onSubmit={(e) => {
                e.preventDefault()
                editingDemoIndex !== null ? updateDemo() : createDemo()
              }}
            >
              {/* Nombre del item */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Nombre del demo</label>
                <input
                  type="text"
                  placeholder="Ej: Dashboard de ventas"
                  value={demoForm.itemName}
                  onChange={(e) => setDemoForm(prev => ({ ...prev, itemName: e.target.value }))}
                  className="w-full text-xs rounded-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2.5"
                  required
                />
              </div>

              {/* Link del item */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Link del demo</label>
                <div className="flex">
                  <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md">
                    <FaLink className="text-xs" />
                  </span>
                  <input
                    type="text"
                    placeholder="https://..."
                    value={demoForm.itemLink}
                    onChange={(e) => setDemoForm(prev => ({ ...prev, itemLink: e.target.value }))}
                    className="flex-1 text-xs rounded-r-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2.5"
                  />
                </div>
              </div>

              {/* Sub-links */}
              <div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 mb-2">
                  <p className="text-[10px] text-gray-500">Si agregas sub-enlaces, el botón desplegará estas opciones en vez de redirigir al link de arriba.</p>
                </div>
                <div className="flex flex-row items-center justify-between mb-2">
                  <label className="block text-xs font-semibold text-gray-700">Sub-enlaces</label>
                  <button
                    type="button"
                    onClick={addSubCategoryLink}
                    className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 font-semibold transition-all"
                  >
                    <FaPlus className="text-[10px]" /> Agregar sub-enlace
                  </button>
                </div>
                {demoForm.subCategoryLinks.length === 0 && (
                  <p className="text-xs text-gray-400 text-center py-2">Sin sub-enlaces</p>
                )}
                <div className="flex flex-col gap-3">
                  {demoForm.subCategoryLinks.map((sub, subIdx) => (
                    <div key={subIdx} className="bg-gray-50 p-3 rounded-lg border border-gray-200 flex flex-col gap-2">
                      <div className="flex flex-row items-end gap-2">
                        <div className="flex-1">
                          <label className="block text-[10px] font-semibold text-gray-500 mb-1">Nombre</label>
                          <input
                            type="text"
                            placeholder="Nombre sub-enlace"
                            value={sub.itemName}
                            onChange={(e) => updateSubCategoryLink(subIdx, "itemName", e.target.value)}
                            className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-[10px] font-semibold text-gray-500 mb-1">Link</label>
                          <input
                            type="text"
                            placeholder="https://..."
                            value={sub.itemLink}
                            onChange={(e) => updateSubCategoryLink(subIdx, "itemLink", e.target.value)}
                            className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                            required
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => removeSubCategoryLink(subIdx)}
                          className="p-2 hover:bg-red-50 rounded-md transition-all"
                        >
                          <FaTrash className="text-red-500 text-xs" />
                        </button>
                      </div>
                      <div className="flex flex-row items-end gap-2">
                        <div className="flex-1">
                          <label className="block text-[10px] font-semibold text-gray-500 mb-1 flex items-center gap-1">
                            <FaUser className="text-[8px]" /> Usuario (opcional)
                          </label>
                          <input
                            type="text"
                            placeholder="usuario@email.com"
                            value={sub.user || ""}
                            onChange={(e) => updateSubCategoryLink(subIdx, "user", e.target.value)}
                            className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-[10px] font-semibold text-gray-500 mb-1 flex items-center gap-1">
                            <FaKey className="text-[8px]" /> Contraseña (opcional)
                          </label>
                          <input
                            type="text"
                            placeholder="••••••••"
                            value={sub.password || ""}
                            onChange={(e) => updateSubCategoryLink(subIdx, "password", e.target.value)}
                            className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Botón de enviar */}
              <Button
                variant="contained"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  paddingBlock: "8px",
                  backgroundColor: "#3b82f6",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "100%",
                  fontSize: "small",
                  '&:hover': { backgroundColor: "#2563eb" }
                }}
                type="submit"
              >
                {editingDemoIndex !== null ? "Actualizar demo" : "Crear demo"}
              </Button>
            </form>
          )}
        </div>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaCode className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Proyectos Software</h2>
          </div>   

          <div className="flex flex-row gap-4 items-center justify-center">

            <MainSaveButton
              text="Registrar demo"
              icon={<AddIcon />}
              onClick={() => setOpenModalDemo(true)}
            />

            {(isAdmin || isOperative) && (
              <Selector
                title="Vista"
                value={view}
                setter={setView}
                width="w-[8rem]"
                options={[{label: "Vertical", value: "Vertical"}, {label: "Horizontal", value: "Horizontal"}]}
                disabled={loadingStatus}
              />
            )}

            <Selector
              title="Límite"
              value={limit}
              setter={setLimit}
              options={Limits10_50}
              width="w-[5rem]"
              disabled={loadingStatus}
            />

            <SearchBar
              value={brandName}
              setter={setBrandName}
              pageSetter={setPage}
              getter={getClients}
              placeholder="Buscar marca..."
              text="Buscar"
              disabled={loadingStatus}
            />

          </div>

        </div>
      </div>

      {/* Filtros de fechas */}       
      <div className="flex flex-row bg-gray-100 mt-0.5 gap-8">
        <div className="flex flex-row w-full items-center gap-4 justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <DateInput
            title="Fecha inicio"
            value={startDate}
            setter={setStartDate}
            disabled={loadingStatus}
          />

          <DateInput
            title="Fecha fin"
            value={endDate}
            setter={setEndDate}
            disabled={loadingStatus}
          />

          <Selector
            title="Responsable"
            value={responsible}
            setter={setResponsible}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{value: "", label: "Todos"}, ...areaWorkers.map((worker) => ({label: worker.name, value: worker.id}))]}
          />
          
          <CheckBox
            checked={agencyWeb}
            onChange={(e) => setAgencyWeb(e.target.checked)}
            disabled={loadingStatus}
            text="Activos Agencia"
          />

          {/* Columnas activas */}
          {view === "Horizontal" && (
            <FilterButton action={() => setShowColFiltersModal(true)} content="Filtros de columnas" />
          )}
        </div>

      </div>

      {/* Software services */}     
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-0.5 py-2 px-4">
        <div className="flex flex-row w-full items-center justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {softwareServices.map((service) => (
            <div
              key={service.id}
              className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300 last:pr-0 last:border-r-0"
            >
              <span className="text-xs font-bold truncate">{service.name}</span>
              <CheckBox
                checked={serviceFilters.includes(service.id)}
                onChange={(e) => handlerChangeServiceFilter(service, e.target.checked)}
                disabled={loadingStatus}
              />
            </div>
          ))}
         </div>
      </div>
      
      {/* Software status */}
      <div className="flex flex-row bg-gray-100 mt-0.5 mb-0.5 py-2 px-4">
        <div className="flex flex-row w-full items-center justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {serviceStatus.map((status) => (
            <div className="flex flex-row items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300">
              <span className="text-xs font-bold truncate">{status.label}</span>
              <CheckBox
                checked={statusFilters.includes(status.value)}
                onChange={(e) => handlerChangeStatusFilter(status.value, e.target.checked)}
                disabled={loadingStatus}
              />
            </div>
          ))}
        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
          ) : (
            clients.length === 0 ? (
              <NoDataScreen />
            ) : (
              view === "Vertical" ? (
                <table className="w-full table-fixed">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-[10px] font-semibold">

                      <td className="w-[15%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div>
                          Cliente
                        </div>
                      </td>
                      {softwareServices
                        .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                        .map((service) => (
                          <td
                            key={service.id}
                            className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                          >
                            <div>{service.name}</div>
                          </td>
                        ))
                      }

                    </tr>
                  </thead>

                  <tbody>
                    {clients.map((client, rowIndex) => (
                    <tr
                      key={client.id}
                      ref={(el) => (serviceRefs.current[clients.indexOf(client)] = el)} // Asignamos la referencia a cada fila
                      className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 
                        ${highlightedRow === rowIndex ? 'bg-orange-100' : ''} // Resaltar la fila si coincide con la fila seleccionada
                      `}
                    >
                        <td 
                          scope="row" 
                          className="max-w-[20px] px-4 py-2 max-w-xs font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100"
                        >
                          <a 
                            href={`/home/seguimiento/${client.id}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            {client.nombreComercial}
                          </a>
                        </td>

                        {softwareServices
                          .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                          .map((service) => (
                            <SoftwareBoxItemContainer 
                              key={service.id} 
                              service={service} 
                              client={client}
                              user={user}
                              permissions={permissions}
                              allServiciosList={softwareServices}
                              workers={workers}
                            />
                          ))
                        }

                      </tr>
                    ))}

                  </tbody>
                </table>  
              ) : (
                <table className="w-full text-xs">
                  <thead className="sticky top-0 bg-gray-200 z-50">
                    <tr className="text-gray-700 text-center text-[10px] font-bold z-50">
                      {colsWithIds
                        .filter(col => shouldShowColumn(col))
                        .map(col => (
                          <th key={col.id} className={`${(col.first || col.second || col.third) ? "sticky" : ""} z-20 px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50`} style={(col.first || col.second || col.third) ? { left: stickyOffsets[col.first ? 'first' : col.second ? 'second' : 'third'] } : undefined}>
                            <div className="flex flex-col items-center justify-center gap-1">
                              {col.name}
                              {col.chipContent ? <span className="text-black">{ChipInfo(col.chipContent)}</span> : null}
                              {col.description ? <TooltipInfoQuestion content={col.description} /> : null}
                            </div>
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {clients.flatMap((c, clientIndex) => {
                      // Renderizar una fila por cada servicio del cliente
                      return (c.services || []).map((service, serviceIndex) => (
                        <SoftwareRowItemContainer
                          key={`${clientIndex}-${serviceIndex}`}
                          sticky={[1, 2]}
                          serviceData={service}
                          c={c}
                          activeCols={colsWithIds}
                          shouldShowColumn={shouldShowColumn}
                          stickyOffsets={stickyOffsets}
                          setClients={setClients}
                          user={user}
                          permissions={permissions}
                          setOpenModalDescription={setOpenModalDescription}
                          setSelectedService={setSelectedService}
                          setOpenModalComments={setOpenModalComments}
                          softwareServices={softwareServices}
                        />
                      ))
                    })}
                  </tbody>
                </table> 
              )
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem 
        actualDocs={clients.reduce((total, client) => total + (client.services || []).length, 0)}
        totalDocs={clients.reduce((total, client) => total + (client.services || []).length, 0)}
        entity={"servicios"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>    
  )
}

export default ProyectosSoftware